<template>
	<div class="home">

		<div class='max-home'>
			<!-- 轮播 -->
			<van-swipe vertical class="my-swipe" indicators :duration="1000" :autoplay="5000" indicator-color="#ffffff">
				<van-swipe-item v-for="(item,index) in bannerArr" :key="index">
					<img class="img" :src="$store.state.website + item.smal1limage">
				</van-swipe-item>
				<template #indicator>
					<div class="noticeCall">
						<div class="noticeCall-in">
							<div class="noticeCall-in-left">
								<div class="noticeCall-in-left-icon">
									<div class="noticeCall-in-left-icon-in"></div>
								</div>
								<div class="noticeCall-in-left-notice">
									<van-notice-bar background='none' color="#fff" class="noticeCall-in-left-notice-in"
										:delay="3" :speed="40" scrollable :text="notice" />
								</div>
							</div>
							<div class="noticeCall-in-right">
								<div class="noticeCall-in-right-icon">
									<div class="noticeCall-in-right-icon-in"></div>
								</div>
								<div class="noticeCall-in-right-call">
									<div class="noticeCall-in-right-call-top">服务热线：</div>
									<div class="noticeCall-in-right-call-bottom">{{$store.state.bannerCall}}</div>
								</div>
							</div>
						</div>
					</div>
				</template>
			</van-swipe>

			<!-- 关于我们 -->
			<div class="about">
				<div class="about-in">
					<transition appear name='aboutLeft'>
						<div class="about-in-left" v-show="aboutLeftShow">
							<img :src="$store.state.website + indexAbout.image" style="width:100%">
						</div>
					</transition>
					<transition appear name='aboutRight'>
						<div class="about-in-right" v-show="aboutRightShow">
							<div class="about-in-right-tit">{{indexAbout.EnglishName}}</div>
							<div class="about-in-right-tits">{{indexAbout.title}}</div>
							<div class="about-in-right-word">{{indexAbout.title1}}</div>
							<div class="about-in-right-words">{{indexAbout.title2}}</div>
							<router-link @click.native="tapHomeInNavBtn('/about')" class="about-in-right-btn"
								to="/about">查看详情</router-link>
						</div>
					</transition>
				</div>
			</div>


			<!-- 我们的服务 -->
			<div class="range">
				<div class="range-in">

					<transition appear name='rangeTit'>
						<div class="range-in-icon" v-show="rangeTitShow" @click="tapRange"></div>
					</transition>

					<transition appear name='rangeTit'>
						<div class="range-in-iconTit" v-show="rangeTitShow"></div>
					</transition>

					<transition appear name='rangeLeft'>
						<div class="range-in-left" v-show="rangeLeftShow">
							<div class="range-in-left-item" @click="tapRange">
								<div class="range-in-left-item-icon">
									<div class="range-in-left-item-icon-in"></div>
								</div>
								<div class="range-in-left-item-tit" v-if="rangeArr[0]">{{rangeArr[0].title}}</div>
								<div class="range-in-left-item-text" v-if="rangeArr[0]">{{rangeArr[0].text}}</div>
							</div>
							<div class="range-in-left-item" @click="tapRange">
								<div class="range-in-left-item-icon">
									<div class="range-in-left-item-icon-in"></div>
								</div>
								<div class="range-in-left-item-tit" v-if="rangeArr[2]">{{rangeArr[2].title}}</div>
								<div class="range-in-left-item-text" v-if="rangeArr[2]">{{rangeArr[2].text}}</div>
							</div>
						</div>
					</transition>

					<transition appear name='rangeRight'>
						<div class="range-in-right" v-show="rangeRightShow">
							<div class="range-in-left-item" @click="tapRange">
								<div class="range-in-left-item-icon">
									<div class="range-in-left-item-icon-in"></div>
								</div>
								<div class="range-in-left-item-tit" v-if="rangeArr[1]">{{rangeArr[1].title}}</div>
								<div class="range-in-left-item-text" v-if="rangeArr[1]">{{rangeArr[1].text}}</div>
							</div>
							<div class="range-in-left-item" @click="tapRange">
								<div class="range-in-left-item-icon">
									<div class="range-in-left-item-icon-in"></div>
								</div>
								<div class="range-in-left-item-tit" v-if="rangeArr[3]">{{rangeArr[3].title}}</div>
								<div class="range-in-left-item-text" v-if="rangeArr[3]">{{rangeArr[3].text}}</div>
							</div>
						</div>
					</transition>

				</div>
				<div class="range-in-btn" @click="tapRange">更多服务</div>
			</div>


			<!-- 案例 -->
			<div class="case">
				<div class="case-bg-mask" :style="{width:width + '%'}"></div>
				<div class="case-in">
					<div class="case-in-tit">
						<div class="case-in-tit-in"></div>
					</div>

					<div class="case-in-fenlei">
						<div class="case-in-fenlei-item" :class="[item.xz?'case-in-fenlei-item-xz':'']"
							v-for="(item,index) in caseFenlei" :key="index" @click="tapFenleiItem(index)">{{item.name}}
						</div>

					</div>

					<div class="case-in-item-box">

						<div class="case-in-item" @click="tapCaseItem" v-for="(item,index) in caseArr" :key="index">
							<!-- <div v-if="index<6"> -->
							<div class="case-in-item-img">
								<img :src="$store.state.website + item.image">
							</div>
							<div class="case-in-item-tit">{{item.title}}</div>
							<div class="case-in-item-text" v-html="item.text"></div>
							<!-- </div> -->
						</div>

					</div>

					<router-link @click.native="tapHomeInNavBtn('/case')" class="case-in-btn" to="/case">查看更多
					</router-link>
				</div>
			</div>


			<!-- 资质荣誉 -->
			<div class="honor">
				<div class="honor-in">
					<transition appear name='honorLeft'>
						<div class="honor-in-left" v-show="honorLeftShow">
							<div class="about-in-right-tit">OUR HONOR</div>
							<div class="about-in-right-tits">{{honorText.title}}</div>
							<div class="about-in-right-word">{{honorText.text}}</div>
							<div class="about-in-right-words">{{honorText.text2}}</div>
							<router-link @click.native="tapHomeInNavBtn('/honor')" class="about-in-right-btn"
								to="/honor">查看更多</router-link>
						</div>
					</transition>
					<transition appear name='honorRight'>
						<div class="honor-in-right" v-show="honorRightShow">
							<div class="honor-in-right-item" v-for="(item,index) in honorArr" :key="index"
								@mouseover="tapHonorItem(index)" @mouseleave='tapHonorItemLeave'>
								<transition appear name='honorBg'>
									<div class="honor-in-right-item-bg" v-show="item.honorBgShow">
										<div class="honor-in-right-item-bg-tit">{{item.title}}</div>
										<div class="honor-in-right-item-bg-text">{{item.text}}</div>
									</div>
								</transition>
								<img :src="$store.state.website + item.image" style="width:100%;" />
							</div>
						</div>
					</transition>
				</div>
			</div>

			<!-- 合作伙伴 -->
			<div class="cooperation">
				<transition appear name='cooperations'>
					<div class="cooperation-in" v-show="cooperationsShow">
						<div class="cooperation-in-tit"></div>
						<div class="cooperation-in-itembox">
							<div class="cooperation-in-itembox-linea"></div>
							<div class="cooperation-in-itembox-lineb"></div>
							<div class="cooperation-in-itembox-linec"></div>
							<div class="cooperation-in-itembox-lined"></div>
							<div class="cooperation-in-itembox-item" v-for="(item,index) in cooperationArr"
								:key="index">
								<img :src="$store.state.website + item.image" />
							</div>
						</div>
					</div>
				</transition>
			</div>

			<!-- 新闻 -->
			<div class="news">
				<transition appear name='newss'>
					<div class="news-in" v-show="newssShow">
						<div class="news-in-tit"></div>
						<div class="news-in-itembox">
							<div class="news-in-itembox-item" @click="tapNewsItem" v-for="(item,index) in newsArr"
								:key="index">
								<div class="news-in-itembox-item-left">
									<div class="news-in-itembox-item-left-in">{{item.Fdate}}</div>
								</div>
								<div class="news-in-itembox-item-right">
									<div class="news-in-itembox-item-right-tit">{{item.title}}</div>
									<div class="news-in-itembox-item-right-text" v-html="item.title1"></div>
								</div>
							</div>
						</div>
					</div>
				</transition>
			</div>


			<!-- 尾banner -->
			<transition appear name='eBanners'>
				<div class="eBanner" v-show="eBannersShow"></div>
			</transition>

			<!-- 页尾 -->
			<PageBottom />
		</div>

		<div class="min-home">

			<van-swipe vertical class="min-my-swipe" indicators :duration="1000" :autoplay="5000"
				indicator-color="#ffffff">
				<van-swipe-item v-for="(item,index) in bannerArrmin" :key="index">
					<img class="min-img" :src="item.images" style="width: 100%;">
				</van-swipe-item>
			</van-swipe>

			<!-- 公告 -->
			<div class="min-home-notice">
				<div class="min-home-notice-in-icon"></div>
				<van-notice-bar background='none' color="#e1e1e1" class="min-home-notice-in" :delay="3" :speed="40"
					scrollable :text="notice" />
				<!-- {{notice}} -->
			</div>

			<!-- icon -->
			<div class="min-icon">

				<div class="min-icon-item" @click="tapMinIcon('服务范围')">
					<div class="min-icon-item-top">
						<img src="../assets/minwufufanweis.png" style="width: 100%;">
					</div>
					<div class="min-icon-item-text">服务范围</div>
				</div>

				<div class="min-icon-item" @click="tapMinIcon('资质荣誉')">
					<div class="min-icon-item-top">
						<img src="../assets/minzizhirongyus.png" style="width: 100%;">
					</div>
					<div class="min-icon-item-text">资质荣誉</div>
				</div>
				<div class="min-icon-item" @click="tapMinIcon('成功案例')">
					<div class="min-icon-item-top">
						<img src="../assets/minanlizhanshis.png" style="width: 100%;">
					</div>
					<div class="min-icon-item-text">成功案例</div>
				</div>
				<div class="min-icon-item" @click="tapMinIcon('新闻资讯')">
					<div class="min-icon-item-top">
						<img src="../assets/minxinwens.png" style="width: 100%;">
					</div>
					<div class="min-icon-item-text">新闻资讯</div>
				</div>
			</div>


			<!-- 关于我们 -->
			<div class="min-home-about">
				<div class="min-home-about-tit">
					<div class="min-home-about-tit-in"></div>
				</div>
				<div class="min-home-about-text">{{indexAbout.title1}}</div>
				<div class="min-home-about-text">{{indexAbout.title2}}</div>
				<div class="min-home-about-btn" @click="tapMinguanyuwm">查看详情</div>
			</div>

			<!-- 服务范围 -->
			<div class="min-home-range">
				<!-- <div class="min-home-range-tit">
					<img src="../assets/fanweiTit.png" style="width:100%">
				</div>
				<div class="min-home-range-tit-icon">
					<img src="../assets/fanweiIn.png" style="width:100%">
				</div>
				<div class="min-home-range-tit-item" v-for="(item,index) in rangeArr" :key="index">
					<div class="min-home-range-tit-item-icon"></div>
					<div class="min-home-range-tit-item-tit">{{item.title}}</div>
					<div class="min-home-range-tit-item-text">{{item.text}}</div>
				</div> -->
				<div class="min-home-range-tit">
					<div class="min-home-range-tit-in"></div>
				</div>
				<div class="min-home-range-item-box">
					<div class="min-home-range-item" v-for="(item,index) in rangeArr" :key="index" @click="tapRange">
						<div class="min-home-range-item-top"><div></div>{{item.title}}</div>
						<div class="min-home-range-item-text">{{item.text}}</div>
					</div>
				</div>

			</div>
			<!-- <div class="" style="clear: both"></div> -->
			<!-- 案例展示 -->
			<div class="min-home-case">
				<!-- <div class="min-home-range-tit min-home-case-tit">
					<img src="../assets/anlitit.png" style="width:100%">
				</div>
				<div class="min-home-case-item" v-for="(item,index) in caseArr" :key="index">
					<div class="min-home-case-item-img">
						<img :src="$store.state.website + item.image" style="width:100%;vertical-align:middle;" />
					</div>
					<div class="min-home-case-tit-item-tit" style="color: #353535; background: #ffffff;">{{item.title}}
					</div>
					<div class="min-home-case-tit-item-text" style="color: #888888; background: #ffffff;">{{item.text}}
					</div>
				</div> -->
				<div class="min-home-case-tit">
					<div class="min-home-case-tit-in"></div>
				</div>
				<div class="min-home-case-fenlei">
					<div class="min-home-case-fenlei-item" :class="[item.xz?'min-home-case-fenlei-item-xz':'']"
						v-for="(item,index) in caseFenlei" :key="index" @click="tapFenleiItem(index)">{{item.name}}
					</div>

				</div>
				<div class="min-home-case-item-box">
					<div class="min-home-case-item" v-for="(item,index) in caseArr" :key="index">
						<div class="min-home-case-item-img">
							<img :src="$store.state.website + item.image" style="width:100%;vertical-align:middle;" />
						</div>
						<div class="min-home-case-item-tit">{{item.title}}</div>
						<div class="min-home-case-item-text" v-html="item.text"></div>
					</div>
				</div>
				<div class="min-home-case-gengduo" @click="tapMinIcon('成功案例')">更多案例</div>
			</div>

			<!-- 荣誉 -->
			<div class="min-home-honor">
				<div class="min-home-honor-tit">
					<div class="min-home-honor-tit-in"></div>
				</div>
				<div class="min-home-honor-item-box">
					<div class="min-home-honor-item" v-for="(item,index) in honorArr" :key="index">
						<img :src="$store.state.website + item.image" style="width: 100%;vertical-align:middle;" />
					</div>
				</div>
				<div class="min-home-case-gengduo" @click="tapHonorItems">更多资质</div>
			</div>
			
			<!-- 合作伙伴 -->
			<div class="min-home-honor">
				<div class="min-home-honor-tit">
					<div class="min-home-honor-tit-in min-home-honor-tit-in-hezuohuoban"></div>
				</div>
				<div class="min-home-honor-item-box">
					<div class="min-home-honor-item" v-for="(item,index) in cooperationArr" :key="index">
						<img :src="$store.state.website + item.image" style="width: 100%;vertical-align:middle;" />
					</div>
				</div>
				<!-- <div class="min-home-case-gengduo">更多资质</div> -->
			</div>
			
			<!-- 新闻资讯 -->
			<div class="min-home-news">
				
				<div class="min-home-honor-tit">
					<div class="min-home-honor-tit-in min-home-honor-tit-in-xinwenzixun"></div>
				</div>
				
				<div class="min-home-news-item" @click="tapNewsItem" v-for="(item,index) in newsArr" :key="index">
					<div class="min-home-news-item-left">
						{{item.Fdate}}
					</div>
					<div class="min-home-news-item-right">
						<div class="min-home-news-item-right-tit">{{item.title}}</div>
						<div class="min-home-news-item-right-text" v-html="item.title1"></div>
					</div>
				</div>
				<div class="min-home-case-gengduo" @click="tapNewsItem">更多资讯</div>
			</div>

			<div class="min-home-lianxiwm">
				<div class="pageBottom-in-c-item pageBottom-in-c-item-tit">联系我们</div>
				<div class="pageBottom-in-c-item">{{$store.state.contact.address}}</div>
				<div class="pageBottom-in-c-item">{{$store.state.contact.tellphone}}</div>
				<div class="pageBottom-in-c-item">{{$store.state.contact.fax}}</div>
				<div class="pageBottom-in-c-item">{{$store.state.contact.phone}}</div>
			</div>

			<div class="min-home-bottom">
				<div class="pageBottom-in-c-item">{{$store.state.contact.copyright}}</div>
				<div class="pageBottom-in-c-item"><a target='blank' style='color: #ffffff;' href="http://beian.miit.gov.cn/">{{$store.state.contact.copyrightNumber}}</a></div>
			</div>


			<div class="" style="height: 3.125rem;"></div>

		</div>
	</div>
</template>

<script>
	import PageBottom from '@/components/PageBottom.vue'

	export default {
		name: 'Home',
		components: {
			PageBottom
		},
		data() {
			return {
				topdh: false,
				width: 80,
				i: 0,
				notice: '',
				aboutLeftShow: false,
				aboutRightShow: false,
				rangeLeftShow: false,
				rangeRightShow: false,
				rangeTitShow: false,
				bannerArr: [],
				bannerArrmin:[
					{
						id: 0,
						images: require('../assets/minbannera.png')
					},
					{
						id: 1,
						images: require('../assets/minbannerb.png')
					},
					{
						id: 2,
						images: require('../assets/minbannerc.png')
					}
				],
				caseArr: [],
				mincaseArrs:[],

				honorArr: [],

				honorLeftShow: false,
				honorRightShow: false,

				cooperationsShow: false,
				newssShow: false,
				eBannersShow: false,

				cooperationArr: [{id: 0,
						img: require('../assets/hzLogo1.png')
					},
					{
						id: 1,
						img: require('../assets/hzLogo2.png')
					},
					{
						id: 2,
						img: require('../assets/hzLogo3.png')
					},
					{
						id: 3,
						img: require('../assets/hzLogo4.png')
					},
					{
						id: 4,
						img: require('../assets/hzLogo5.png')
					},
					{
						id: 5,
						img: require('../assets/hzLogo6.png')
					},
					{
						id: 6,
						img: require('../assets/hzLogo7.png')
					},
					{
						id: 7,
						img: require('../assets/hzLogo8.png')
					},
					{
						id: 8,
						img: require('../assets/hzLogo9.png')
					},
				],
				indexAbout: {},
				rangeArr: [],
				honorText: {},
				newsArr: [],
				contact: {},

				caseFenlei: [],

			}
		},
		mounted() {
			let that = this;
			//监听（绑定）滚轮 滚动事件
			window.addEventListener('scroll', that.handleScroll, true);

			window.pageYOffset = 0;
			document.documentElement.scrollTop = 0;
			document.body.scrollTop = 0

			// 获取banner数据
			that.$axios.post('http://www.sy-eray.com/index.php/api/demo/shpouye ', {
				// 'aa':1
			}).
			then(function(response) {
				console.log('banner', response)
				that.bannerArr = response.data.data;

			}).catch(function(error) {
				console.log(error);
			});

			//获取公告内容数据
			that.$axios.post('http://www.sy-eray.com/index.php/api/demo/gonggao', {
				// 'aa':1
			}).then(function(response) {
				// console.log('公告', response.data.data);
				// if(response.data.data){
				that.notice = response.data.data[0].content;
				// }
			}).catch(function(error) {
				console.log(error);
			});

			//获取关于我们数据
			that.$axios.post('http://www.sy-eray.com/index.php/api/demo/gywm', {
				// 'aa':1
			}).then(function(response) {
				// console.log('关于我们', response.data.data)
				that.indexAbout = response.data.data;

			}).catch(function(error) {
				console.log(error);
			});

			//获取我们的服务范围数据
			that.$axios.post('http://www.sy-eray.com/index.php/api/demo/fwfw', {
				// 'aa':1
			}).then(function(response) {
				// console.log('服务范围', response.data.data)
				that.rangeArr = response.data.data.reverse();

			}).catch(function(error) {
				console.log(error);
			});

			//获取案例分类 
			that.$axios.post('http://www.sy-eray.com/index.php/api/demo/alfl', {
				// 'aa':1
			}).then(function(response) {
				let id;
				let w = document.documentElement.clientWidth;
				// console.log(w)
				if(w<1200){ //手机
					// console.log('手机');
					let item = {
						id: 0,
						name: '全部',
						xz: true
					};
					let caseFenlei = response.data.data;
					caseFenlei.forEach(function(item) {
						item.xz = false
					})
					// caseFenlei[0].xz = true;
					caseFenlei.unshift(item);
					that.caseFenlei = caseFenlei;
					// console.log('案例分类',that.caseFenlei);
					
					//获取案例数据
					that.$axios.post('http://www.sy-eray.com/index.php/api/demo/alilist', {
						'id': 0,
					}).then(function(response) {
						// console.log('案例', response.data.data)
						let caseArrs = response.data.data;
						caseArrs.splice(6, caseArrs.length - 1); //值保留前6个
						that.caseArr = caseArrs;
						
						that.mincaseArrs = caseArrs;
						that.mincaseArrs.forEach(function(item){
							item.text = item.text.replace(/<[^>]+>/g,"");
							item.text = item.text.replace(/&nbsp;/ig,""); 
						})
					}).catch(function(error) {
						console.log(error);
					});
				}else{ //电脑
					// console.log('电脑')
					
					let caseFenlei = response.data.data;
					
					caseFenlei.forEach(function(item,index) {
						item.xz = false;
						if(item.name == '自动化'){
							let a = item;
							a.xz = true;
							id = item.id;
							caseFenlei.splice(index,1);
							caseFenlei.unshift(a);
						}
					})
					// console.log('caseFenlei',caseFenlei)
					that.caseFenlei = caseFenlei;
					// console.log('案例分类',that.caseFenlei);
					//获取案例数据
					that.$axios.post('http://www.sy-eray.com/index.php/api/demo/alilist', {
						'id': id,
					}).then(function(response) {
						// console.log('案例', response.data.data)
						let caseArrs = response.data.data;
						caseArrs.splice(6, caseArrs.length - 1); //值保留前6个
						that.caseArr = caseArrs;
						
						that.mincaseArrs = caseArrs;
						that.mincaseArrs.forEach(function(item){
							item.text = item.text.replace(/<[^>]+>/g,"");
							item.text = item.text.replace(/&nbsp;/ig,""); 
						})
					}).catch(function(error) {
						console.log(error);
					});
				}
				
				

			}).catch(function(error) {
				console.log(error);
			});

			

			//资质荣誉
			that.$axios.post('http://www.sy-eray.com/index.php/api/demo/zzrylist', {
				// 'aa':1
			}).then(function(response) {
				console.log(response)
				let IndexHonorindex = response.data.data;
				let honorArrs = IndexHonorindex.list;
				honorArrs.splice(4, honorArrs.length - 1); //值保留前4个
				honorArrs.forEach(function(item) {
					item.honorBgShow = false;
				})
				// that.honorArr = honorArrs.reverse();
				that.honorArr = honorArrs;
				that.honorText = IndexHonorindex;

			}).catch(function(error) {
				console.log(error);
			});

			//获取合作伙伴数据
			that.$axios.post('http://www.sy-eray.com/index.php/api/demo/hzhb', {
				// 'aa':1
			}).then(function(response) {

				let cooperationArrs = response.data.data;
				cooperationArrs.splice(9, cooperationArrs.length - 1); //值保留前9个
				that.cooperationArr = cooperationArrs;
				console.log('合作', that.cooperationArr);

			}).catch(function(error) {
				console.log(error);
			});

			//获取新闻数据
			that.$axios.post('http://www.sy-eray.com/index.php/api/demo/newslist', {
				// 'aa':1
			}).then(function(response) {

				let newsArrs = response.data.data;
				newsArrs.splice(4, newsArrs.length - 1); //值保留前4个
				newsArrs.forEach(function(item) {
					item.Fdate = item.Fdate.split('-')[1] + '-' + item.Fdate.split('-')[2];
					// console.log(item.Fdate)
				})
				that.newsArr = newsArrs;
				// console.log('新闻', that.newsArr);

			}).catch(function(error) {
				console.log(error);
			});




		},
		methods: {
			// tapBanners() {
			// 	let that = this;
			// 	// let aaa = 'at.86ocytdw51gf600zag9s4n3ncpu8h2ls-45gm6bqut4-1k847vq-bxxhipknc';
			// 	that.$axios.post(
			// 	// 'https://open.ys7.com/api/lapp/live/video/list?accessToken=' + aaa +
			// 	// 	'&pageStart=0&pageSize=100'
			// 	'/banner/fapig/douyin/billboard?key=&type=hot_video'
			// 		, {
			// 		// 'aa':1
			// 	}, {
			// 		headers: {
			// 			// 'Content-type': 'application/x-www-form-urlencoded'
			// 		}
			// 	}).then(function(response) {
			// 		console.log('banner------', response)
			// 	}).catch(function(error) {
			// 		console.log('banner------', error);
			// 	});

			// },

			//点击案例分类
			tapFenleiItem(e) {
				let that = this;
				// console.log(e);
				that.caseFenlei.forEach(function(item) {
					item.xz = false;
				})
				that.caseFenlei[e].xz = true;
				//获取案例数据
				that.$axios.post('http://www.sy-eray.com/index.php/api/demo/alilist', {
					'id': that.caseFenlei[e].id,
				}).then(function(response) {
					// console.log('案例', response.data.data)
					let caseArrs = response.data.data;
					caseArrs.splice(6, caseArrs.length - 1); //值保留前6个
					that.caseArr = caseArrs;
					
					that.mincaseArrs = caseArrs;
					that.mincaseArrs.forEach(function(item){
						item.text = item.text.replace(/<[^>]+>/g,"");
						item.text = item.text.replace(/&nbsp;/ig,""); 
					})
					

				}).catch(function(error) {
					console.log(error);
				});
			},

			//点击服务
			tapRange() {
				this.$router.push({
					path: '/range'
				})
				this.$store.commit('path', '/range')
			},
			


			//点击新闻某一个
			tapNewsItem() {
				this.$router.push({
					path: '/news'
				})
				this.$store.commit('path', '/news')
			},
			
			//点击资质
			tapHonorItems(){
				this.$router.push({
					path: '/honor'
				})
				this.$store.commit('path', '/honor')
			},

			//点击案例展示img
			tapCaseItem() {
				this.$router.push({
					path: '/case'
				})
				this.$store.commit('path', '/case')
			},

			//点击更多、详情按钮
			tapHomeInNavBtn(e) {
				this.$store.commit('path', e)
			},


			handleScroll() {
				let that = this;
				// 页面滚动距顶部距离
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
					document.body.scrollTop
				var scroll = scrollTop - that.i;
				// console.log('scrollTop',scrollTop)
				that.i = scrollTop;
				if (scroll < 0) {
					// console.log('up')
					// console.log(that.i)
					if (that.i < 3300) { //案例展示动画
						if (that.width !== 80) {
							that.width += 2;
						}
					}
					// console.log(that.width)
					if (that.i < 500) { //关于我们动画
						that.aboutLeftShow = false
						that.aboutRightShow = false
					}
					if (that.i < 1600) { //服务范围动画
						that.rangeLeftShow = false
						that.rangeRightShow = false
					}
					if (that.i < 1100) { //服务范围动画
						that.rangeTitShow = false
					}
					if (that.i < 3400) { //荣誉动画
						that.honorLeftShow = false
						that.honorRightShow = false
					}
					if (that.i < 4200) { //合作动画
						that.cooperationsShow = false
					}
					if (that.i < 5000) { //新闻动画
						that.newssShow = false
					}
					if (that.i < 5100) { //5400
						that.eBannersShow = false
					}
					if (that.i < 200) {
						that.$store.commit('navOpacityNum', false);
					}
				} else {
					// console.log('down')
					// console.log(that.i)
					if (that.i > 2200) { //案例展示动画
						if (that.width !== 0) {
							that.width -= 2;
						}
					}
					// console.log(that.width)
					if (that.i > 500) { //关于我们动画
						that.aboutLeftShow = true
						that.aboutRightShow = true
					}
					if (that.i > 1600) { //服务范围动画
						that.rangeLeftShow = true
						that.rangeRightShow = true
					}
					if (that.i > 1100) { //服务范围动画
						that.rangeTitShow = true
					}
					if (that.i > 3300) { //荣誉动画
						that.honorLeftShow = true
						that.honorRightShow = true
					}
					if (that.i > 4200) { //合作动画
						that.cooperationsShow = true
					}
					if (that.i > 5000) { //新闻动画
						that.newssShow = true
					}
					if (that.i > 5100) { //5400
						that.eBannersShow = true
					}
					if (that.i > 200) {
						that.$store.commit('navOpacityNum', true);
					}
				}
			},

			//移入某个荣誉
			tapHonorItem(e) {
				// console.log(e)
				let that = this;
				that.honorArr[e].honorBgShow = true
			},
			//移出荣誉
			tapHonorItemLeave() {
				let that = this;
				that.honorArr.forEach(function(item) {
					item.honorBgShow = false
				})
			},


			//点击移动端icon
			tapMinIcon(e) {
				console.log(e);
				if (e == '服务范围') {
					this.$router.push({
						name: 'Range',
						// params: {
						// 	item: item
						// }
					})
					this.$store.commit('tapNavItem', 3);
				} else if (e == '资质荣誉') {
					this.$router.push({
						name: 'Honor',
						// params: {
						// 	item: item
						// }
					})
					this.$store.commit('tapNavItem', 2);
				} else if (e == '成功案例') {
					this.$router.push({
						name: 'Case',
						// params: {
						// 	item: item
						// }
					})
					this.$store.commit('tapNavItem', 5);
				} else if (e == '新闻资讯') {
					this.$router.push({
						name: 'News',
						// params: {
						// 	item: item
						// }
					})
					this.$store.commit('tapNavItem', 1);
				}

			},

			//点击关于我们详情按钮
			tapMinguanyuwm() {
				this.$router.push({
					name: 'About',
					// params: {
					// 	item: item
					// }
				})
				this.$store.commit('tapNavItem', 4);
			}

		}
	}
</script>

<style>
	.home {
		width: 100%;
		height: 100%;
	}


	/* banner */

	.my-swipe {
		width: 100%;
		height: 900px;
		margin: 0;
		padding: 0;
	}

	.my-swipe .van-swipe-item {
		text-align: center;
		/* background-color: #39a9ed; */
	}

	.img {
		width: 100%;
		height: 900px;
	}

	.noticeCall {
		width: 100%;
		height: 70px;
		background: #323232;
		position: absolute;
		bottom: 0;
		left: 0;
		opacity: .9;
	}

	.noticeCall-in {
		width: 1200px;
		height: 100%;
		/* background: red; */
		margin: 0 auto;
		/* opacity: .9; */
	}

	.noticeCall-in-left {
		width: calc(100% - 280px);
		height: 100%;
		float: left;
	}

	.noticeCall-in-right {
		width: 280px;
		height: 100%;
		float: left;
		background: #fed24f;
		/* opacity: .9; */
		padding-left: 30px;
		box-sizing: border-box;
	}

	.noticeCall-in-right-icon {
		width: 36px;
		height: 100%;
		/* background: red; */
		float: left;
		position: relative;
	}

	.noticeCall-in-right-icon-in {
		width: 36px;
		height: 36px;
		background-image: url(../assets/call.png);
		background-size: 100% 100%;
		position: absolute;
		top: calc(50% - 18px);
		left: 0;
	}

	.noticeCall-in-right-call {
		width: calc(100% - 36px);
		height: 100%;
		/* background: tan; */
		float: left;
		padding-left: 10px;
		box-sizing: border-box;
	}

	.noticeCall-in-left-icon {
		width: 30px;
		height: 100%;
		/* background: pink; */
		float: left;
		position: relative;
	}

	.noticeCall-in-left-icon-in {
		width: 30px;
		height: 30px;
		position: absolute;
		left: 0;
		top: calc(50% - 15px);
		background-image: url(../assets/gonggao.png);
		background-size: 100% 100%;
	}

	.noticeCall-in-left-notice {
		width: calc(100% - 30px);
		height: 100%;
		/* background: tan; */
		float: left;
		padding: 0 100px 0 5px;
		box-sizing: border-box;
		font-size: 16px;
		color: #ffffff;
		line-height: 70px;
		padding-top: 15px;
	}

	.noticeCall-in-left-notice-in {
		width: 100%;
	}

	.noticeCall-in-right-call-top,
	.noticeCall-in-right-call-bottom {
		width: 100%;
		height: 50%;
		font-size: 14px;
		color: #ffffff;
	}

	.noticeCall-in-right-call-top {
		/* background: red; */
		line-height: 44px;
	}

	.noticeCall-in-right-call-bottom {
		/* background: tan; */
		font-size: 24px;
		line-height: 24px;
	}

	/* banner结束 */

	/* 关于我们 */
	.aboutLeft-enter,
	.aboutLeft-leave-to {
		opacity: 0;
		transform: translateX(-100px);
	}

	.aboutLeft-enter-active,
	.aboutLeft-leave-active {
		transition: all 1s ease;
	}

	.aboutRight-enter,
	.aboutRight-leave-to {
		opacity: 0;
		transform: translateX(100px);
	}

	.aboutRight-enter-active,
	.aboutRight-leave-active {
		transition: all 1s ease;
	}

	.about {
		width: 100%;
		height: 922px;
		background: #ffffff;
		padding: 100px 0;
		box-sizing: border-box;
	}

	.about-in {
		width: 1200px;
		height: 100%;
		/* background: red; */
		margin: 0 auto;
	}

	.about-in-left {
		width: 602px;
		height: 722px;
		/* 		background-image: url(../assets/guanyu.png);
		background-size: 100% 100%; */
		float: left;
	}

	.about-in-right {
		width: calc(100% - 602px);
		height: 722px;
		/* background: #009C41; */
		float: left;
		padding-left: 100px;
		box-sizing: border-box;
		font-weight: bold;
	}

	.about-in-right-tit {
		width: 100%;
		font-size: 22px;
		color: #666666;
		margin-top: 107px;
		box-sizing: border-box;
		letter-spacing: 4px;
		font-weight: bold;
	}

	.about-in-right-tits {
		width: 100%;
		font-size: 40px;
		color: #333333;
		margin-top: 5px;
		box-sizing: border-box;
		font-weight: bold;
	}

	.about-in-right-word {
		font-size: 18px;
		color: #555555;
		line-height: 30px;
		width: 100%;
		margin-top: 50px;
		box-sizing: border-box;
	}

	.about-in-right-words {
		font-size: 18px;
		color: #888888;
		line-height: 30px;
		width: 100%;
		margin-top: 50px;
		box-sizing: border-box;
	}

	.about-in-right-btn {
		width: 200px;
		height: 60px;
		margin-top: 50px;
		border: 2px #c0c0c0 solid;
		box-sizing: border-box;
		text-align: center;
		line-height: 60px;
		font-size: 18px;
		color: #444444;
		cursor: pointer;
		display: block;
	}


	.about-in-right-btn:hover {
		color: #ffffff;
		border: 2px #52dedb solid;
		background: #52dedb;
	}

	/* 关于我们结束 */

	/* 服务范围 */
	.rangeTit-enter,
	.rangeTit-leave-to {
		opacity: 0;
		transform: translateY(-100px);
	}

	.rangeTit-enter-active,
	.rangeTit-leave-active {
		transition: all 1s ease;
	}

	.rangeLeft-enter,
	.rangeLeft-leave-to {
		opacity: 0;
		transform: translateX(-100px);
	}

	.rangeLeft-enter-active,
	.rangeLeft-leave-active {
		transition: all 1s ease;
	}

	.rangeRight-enter,
	.rangeRight-leave-to {
		opacity: 0;
		transform: translateX(100px);
	}

	.rangeRight-enter-active,
	.rangeRight-leave-active {
		transition: all 1s ease;
	}


	.range {
		width: 100%;
		height: 977px;
		/* background: #009C41; */
		background-image: url(../assets/fanwei.jpg);
		background-size: 100% 100%;
		position: relative;
	}

	.range-in {
		width: 1200px;
		height: 777px;
		/* background: #000; */
		margin: 0 auto;
	}

	.range-in-btn {
		width: 200px;
		height: 60px;
		/* margin-top: 100px; */
		border: 1px #ffffff solid;
		box-sizing: border-box;
		text-align: center;
		line-height: 60px;
		font-size: 18px;
		color: #ffffff;
		cursor: pointer;
		position: absolute;
		bottom: 100px;
		left: calc(50% - 100px);
		display: block;
		/* background: red; */
	}

	.range-in-btn:hover {
		border: 1px #ffffff solid;
		background: #52dedb;
	}

	.range-in-icon {
		width: 456px;
		height: 386px;
		position: absolute;
		bottom: 300px;
		left: calc(50% - 228px);
		background-image: url(../assets/fanweiIn.png);
		background-size: 100% 100%;
		/* animation: rbox 90s linear infinite; */
		transition: all 2s;
		cursor: pointer;
	}

	.range-in-icon:hover {
		transform: translateY(-10px);
		transform: scale(1.1);
		/* transform: rotate(360deg); */
	}

	.range-in-iconTit {
		width: 481px;
		height: 70px;
		position: absolute;
		top: 85px;
		left: calc(50% - 240.5px);
		background-image: url(../assets/fanweiTit.png);
		background-size: 100% 100%;
	}

	.range-in-left,
	.range-in-right {
		width: 330px;
		height: 100%;
		/* background: red; */
		float: left;
		padding-top: 256px;
		padding-bottom: 80px;
		box-sizing: border-box;
	}

	.range-in-right {
		float: right;
	}

	.range-in-left-item,
	.range-in-right-item {
		width: 100%;
		height: 50%;
		/* background: #009C41; */
		transition: all .5s;
		cursor: pointer;
	}

	.range-in-left-item:hover {
		transform: translateY(-10px);
	}

	.range-in-left-item-icon {
		width: 100%;
		height: 50px;
		/* background: pink; */
	}

	.range-in-left-item-tit {
		width: 100%;
		/* height: 50px; */
		font-size: 20px;
		color: #ffffff;
		margin-top: 20px;
		margin-bottom: 8px;
		box-sizing: border-box;
	}

	.range-in-left-item-text {
		width: 100%;
		height: 75px;
		font-size: 16px;
		color: #ffffff;
		line-height: 26px;
		/* 超过2行省略号 */
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
		overflow: hidden;
	}

	.range-in-left-item-icon-in {
		width: 50px;
		height: 50px;
		background: #52dedb;
		opacity: .9;
		border-radius: 50%;
		background-image: url(../assets/fuwumin.png);
		background-size: 100% 100%;
	}

	@keyframes rbox {
		from {
			transform: rotate(0deg);
		}

		to {
			transform: rotate(360deg);
		}
	}

	/* 服务范围结束 */

	/* 案例 */
	.case {
		width: 100%;
		height: 1440px;
		/* background: #19b7c8; */
		background-image: url(../assets/anliBG.jpg);
		background-size: 100% 100%;
		/* background: rgba(25,183,200 .2); */
		position: relative;
	}

	.case-bg-mask {
		/* width: 100%; */
		height: 100%;
		background: #f6fdfe;
		position: absolute;
		top: 0;
		right: 0;
	}

	.case-in {
		width: 1200px;
		/* 1297 */
		height: 1440px;
		/* background: red; */
		position: absolute;
		top: 0;
		left: calc(50% - 600px);
		padding-top: 100px;
		box-sizing: border-box;
	}

	.case-in-tit {
		width: 100%;
		height: 70px;
		/* background: pink; */
		position: relative;
		margin-bottom: 100px;

		box-sizing: border-box;
	}

	.case-in-tit-in {
		width: 479px;
		height: 70px;
		background-image: url(../assets/anlitit.png);
		background-size: 100% 100%;
		position: absolute;
		top: 0;
		left: calc(50% - 239.5px);
	}

	.case-in-fenlei {
		width: 100%;
		height: auto;
		/* background: red; */
		margin-bottom: 50px;
		box-sizing: border-box;
		color: #c6c7c7;
		/* 		overflow-y: hidden;
		overflow-x: scroll;
		white-space: nowrap; */
	}

	.case-in-fenlei-item {
		width: 120px;
		height: 100%;
		margin-right: 30px;
		box-sizing: border-box;
		border-radius: 30px;
		font-size: 16px;
		line-height: 50px;
		text-align: center;
		border: 1px solid #ededed;
		cursor: pointer;
		display: inline-block;
		margin-bottom: 20px;
	}

	.case-in-fenlei-item-xz {
		background: #ffffff;
		color: #52dedb;
		border: 1px solid #ededed;
		font-weight: bold;
	}

	.case-in-fenlei-item:hover {
		background: #ffffff;
		color: #52dedb;
		border: 1px solid #ededed;
		font-weight: bold;
	}

	.case-in-item-box {
		width: 100%;
		height: 780px;
	}

	.case-in-item {
		width: 380px;
		height: 370px;
		background: #ffffff;
		float: left;
		margin-right: 20px;
		box-sizing: border-box;
		margin-bottom: 20px;
		box-shadow: 0px 0px 10px #f4ffff;
		cursor: pointer;
		transition: all .5s;
	}

	.case-in-btn {
		width: 200px;
		height: 60px;
		/* margin-top: 100px; */
		border: 2px #ffffff solid;
		box-sizing: border-box;
		text-align: center;
		line-height: 60px;
		font-size: 18px;
		color: #ffffff;
		cursor: pointer;
		margin: 60px auto 0 auto;
		display: block;
		/* background: red; */
	}

	.case-in-btn:hover {
		color: #52dedb;
		border: 2px #ffffff solid;
		background: #ffffff;
		font-weight: bold;
	}

	.case-in-item-img {
		width: 100%;
		height: 230px;
		/* background: red; */
		transition: all .5s;
		position: relative;
		overflow: hidden;
	}

	.case-in-item-img img {
		width: 100%;
		height: 100%;
		transition: all .5s;
		position: absolute;
	}

	.case-in-item-img:hover img {
		transform: scale(1.2);
	}

	.case-in-item:hover {
		transform: translateY(-10px);
	}

	.case-in-item-tit {
		width: 100%;
		height: auto;
		font-size: 20px;
		color: #333333;
		/* font-weight: bold; */
		padding: 0 20px;
		box-sizing: border-box;
		margin-top: 30px;
	}

	.case-in-item-text {
		width: 100%;
		height: auto;
		font-size: 16px;
		color: #777777;
		/* font-weight: bold; */
		padding: 0 20px;
		box-sizing: border-box;
		margin-top: 10px;
		line-height: 26px;
		/* 超过2行省略号 */
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	/* 案例结束 */

	/* 资质荣誉 */

	.honorLeft-enter,
	.honorLeft-leave-to {
		opacity: 0;
		transform: translateX(-100px);
	}

	.honorLeft-enter-active,
	.honorLeft-leave-active {
		transition: all 1s ease;
	}

	.honorRight-enter,
	.honorRight-leave-to {
		opacity: 0;
		transform: translateX(100px);
	}

	.honorRight-enter-active,
	.honorRight-leave-active {
		transition: all 1s ease;
	}

	.honorBg-enter,
	.honorBg-leave-to {
		opacity: 0;
		transform: translateY(50px);
	}

	.honorBg-enter-active,
	.honorBg-leave-active {
		transition: all 0.5s ease;
	}

	.honor {
		width: 100%;
		height: 740px;
		/* background: red; */
	}

	.honor-in {
		width: 1200px;
		height: 100%;
		margin: 0 auto;
		/* background: pink; */
	}

	.honor-in-left {
		width: 470px;
		height: 100%;
		/* background: pink; */
		float: left;
		padding-right: 80px;
		padding-top: 10px;
		box-sizing: border-box;
	}

	.honor-in-right {
		width: 730px;
		height: 100%;
		/* background: red; */
		float: left;
		padding: 100px 0;
		box-sizing: border-box;
	}

	.honor-in-right-item {
		width: 335px;
		height: 260px;
		float: left;
		background: pink;
		margin-left: 20px;
		margin-bottom: 20px;
		box-sizing: border-box;
		position: relative;
		box-shadow: 0px 0px 20px #e6e6e8;
		cursor: pointer;
		transition: all .5s;
		overflow: hidden;
	}

	.honor-in-right-item:hover {
		transform: translateY(-10px);
	}

	.honor-in-right-item-bg {
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, .5);
		position: absolute;
		top: 0;
		left: 0;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.honor-in-right-item-bg-tit {
		width: 100%;
		font-size: 20px;
		color: #ffffff;
		line-height: 70px;
	}

	.honor-in-right-item-bg-text {
		width: 100%;
		font-size: 16px;
		color: #f7f7f7;
		line-height: 26px;
		/* 超过2行省略号 */
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 5;
		overflow: hidden;
	}

	/* 资质荣誉结束 */

	/* 合作 */
	.cooperations-enter,
	.cooperations-leave-to {
		opacity: 0;
		transform: translateX(100px);
	}

	.cooperations-enter-active,
	.cooperations-leave-active {
		transition: all 1s ease;
	}

	.cooperation {
		width: 100%;
		height: 906px;
		background: #f8f8f8;
		padding-top: 100px;
		box-sizing: border-box;
	}

	.cooperation-in {
		width: 1200px;
		height: 100%;
		/* background: #ffffff; */
		margin: 0 auto;
	}

	.cooperation-in-tit {
		width: 458px;
		height: 68px;
		background-image: url(../assets/hezuoTit.png);
		background-size: 100% 100%;
		margin: 0 auto;
	}

	.cooperation-in-itembox {
		width: 100%;
		height: 540px;
		background: #ffffff;
		margin-top: 100px;
		box-sizing: border-box;
		position: relative;
	}

	.cooperation-in-itembox-linea {
		width: 1200px;
		height: 1px;
		background: #e0e0e0;
		position: absolute;
		top: 180px;
		left: 0;
	}

	.cooperation-in-itembox-lineb {
		width: 1200px;
		height: 1px;
		background: #e0e0e0;
		position: absolute;
		top: 360px;
		left: 0;
	}

	.cooperation-in-itembox-linec {
		width: 1px;
		height: 540px;
		background: #e0e0e0;
		position: absolute;
		top: 0px;
		left: 400px;
	}

	.cooperation-in-itembox-lined {
		width: 1px;
		height: 540px;
		background: #e0e0e0;
		position: absolute;
		top: 0px;
		left: 800px;
	}

	.cooperation-in-itembox-item {
		width: 400px;
		height: 180px;
		/* background: pink; */
		float: left;
		cursor: pointer;
		overflow: hidden;
	}

	.cooperation-in-itembox-item:hover {
		border: 2px solid rgba(255, 255, 255, 0);
		box-sizing: border-box;
	}

	/* 合作结束 */

	/* 新闻 */
	.newss-enter,
	.newss-leave-to {
		opacity: 0;
		transform: translateX(-100px);
	}

	.newss-enter-active,
	.newss-leave-active {
		transition: all 1s ease;
	}

	.news {
		width: 100%;
		height: 677px;
	}

	.news-in {
		width: 1200px;
		height: 100%;
		/* background: #ccc; */
		margin: 0 auto;
		padding-top: 100px;
		box-sizing: border-box;
	}

	.news-in-tit {
		width: 704px;
		height: 70px;
		margin: 0 auto;
		background-image: url(../assets/xinwentit.png);
		background-size: 100% 100%;
	}

	.news-in-itembox {
		width: 1200px;
		height: 300px;
		/* background: red; */
		margin-top: 100px;
		box-sizing: border-box;
	}

	.news-in-itembox-item {
		width: 580px;
		height: 140px;
		background: #ffffff;
		float: left;
		margin-right: 20px;
		margin-bottom: 20px;
		box-sizing: border-box;
		padding: 0 30px;
		transition: all 0.5s;
	}

	.news-in-itembox-item:hover {
		box-shadow: 0px 0px 20px #e6e6e8;
		cursor: pointer;
		transform: translateY(-10px);
		background: #52dedb;
	}

	.news-in-itembox-item:hover .news-in-itembox-item-right-tit {
		color: #ffffff;
	}

	.news-in-itembox-item:hover .news-in-itembox-item-right-text {
		color: #ffffff;
	}

	.news-in-itembox-item-left {
		width: 80px;
		height: 100%;
		/* background: pink; */
		float: left;
		position: relative;
	}

	.news-in-itembox-item-right {
		width: calc(100% - 80px);
		height: 100%;
		/* background: tan; */
		float: left;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.news-in-itembox-item-left-in {
		width: 80px;
		height: 80px;
		background: #52dedb;
		border-radius: 50%;
		position: absolute;
		top: calc(50% - 40px);
		left: 0;
		line-height: 80px;
		text-align: center;
		color: #ffffff;
		font-size: 18px;
		transition: all 0.5s;
	}

	.news-in-itembox-item:hover .news-in-itembox-item-left-in {
		color: #52dedb;
		background: #ffffff;
	}

	.news-in-itembox-item-right-tit {
		width: 100%;
		height: auto;
		/* line-height: 70px; */
		padding: 30px 0 10px 0;
		font-size: 18px;
		color: #333333;

		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.news-in-itembox-item-right-text {
		width: 100%;
		height: auto;
		line-height: 26px;
		font-size: 16px;
		color: #888888;
		/* 超过2行省略号 */
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	/* 新闻结束 */
	.eBanner {
		width: 100%;
		height: 360px;
		background-image: url(../assets/bottomBanner.png);
		background-size: 100% 100%;
	}

	.eBanners-enter,
	.eBanners-leave-to {
		opacity: 0;
		transform: translateY(100px);
	}

	.eBanners-enter-active,
	.eBanners-leave-active {
		transition: all 1s ease;
	}


	.min-home {
		display: none;
	}

	@media only screen and (max-width: 1200px) {
		.home {
			width: 100%;
			height: auto;
			background: #f8f8f8;
		}

		.max-home {
			display: none;
		}

		.min-home {
			display: block;
		}

		.min-home-notice {
			width: 100%;
			height: 3.125rem;
			background: #343434;
			overflow: hidden;
			position: relative;
		}

		.min-home-notice-in {
			position: absolute;
			top: 0.375rem;
			left: 2.8125rem;
			font-size: 0.875rem;
			color: #e1e1e1;
			width: 100%;
		}
		.min-home-notice-in-icon{
			width: 1.75rem;
			height: 1.75rem;
			position: absolute;
			top: calc(50% - 14px);
			left: 1.25rem;
			/* background: red; */
			background-image: url(../assets/mingonggaoixons.png);
			background-size: 100% 100%;
		}

		.min-home-about {
			width: 100%;
			height: auto;
			padding: 0 0.9375rem;
			box-sizing: border-box;
			background: #ffffff;
			margin-top: 0.625rem;
			padding-top: 1.5rem;
			padding-bottom: 1.5rem;
		}

		.min-home-about-tit {
			width: 100%;
			height: 1.59375rem;
			padding-bottom: 0.5rem;
			/* background: red; */
		}

		.min-home-about-tit-in {
			width: 11.21875rem;
			height: 1.59375rem;
			margin: 0 auto;
			background-image: url(../assets/minguanyuwm.png);
			background-size: 100% 100%;
		}

		.min-home-about-text {
			width: 100%;
			height: auto;
			font-size: 0.875rem;
			color: #666666;
			line-height: 1.75rem;
			margin-top: 1rem;
			box-sizing: border-box;
		}

		.min-home-about-btn {
			width: 5.5rem;
			height: 1.875rem;
			/* background: #4f4f4f; */
			border: 1px solid #fed24f;
			text-align: center;
			line-height: 1.875rem;
			font-size: 0.875rem;
			color: #fed24f;
			margin: 0 auto;
			margin-top: 2.1875rem;
			box-sizing: border-box;
			border-radius: 5px;
		}




		.min-home-range {
			width: 100%;
			height: auto;
			background: #ffffff;
			margin-top: 0.625rem;
			padding-top: 1.5rem;
			box-sizing: border-box;
			padding-bottom: 1.5rem;
		}

		.min-home-range-tit {
			width: 100%;
			height: 1.625rem;
			/* background: pink; */
			margin-bottom: 1.5rem;
			box-sizing: border-box;
		}

		.min-home-range-tit-in {
			width: 10.46875rem;
			height: 1.625rem;
			background-image: url(../assets/minwmdfuwufanwei.png);
			background-size: 100% 100%;
			margin: 0 auto;
		}

		.min-home-range-item-box {
			width: 100%;
			height: auto;
			/* height: 50rem; */
			/* background: pink; */
			padding: 0 0.9375rem 0 0.3125rem;
			box-sizing: border-box;

		}

		.min-home-range-item {
			width: calc(100% / 2 - 10px);
			height: 9.375rem;
			background: #f8f8f8;
			/* float: left; */
			display: inline-block;
			margin-left: 0.625rem;
			box-sizing: border-box;
			margin-bottom: 0.625rem;
			padding: 0 0.625rem;
			box-sizing: border-box;
			vertical-align: top;
		}

		.min-home-range-item-top {
			width: 100%;
			height: auto;
			font-size: 1rem;
			color: #353535;
			padding: 1.25rem 0 0.875rem 0;
			box-sizing: border-box;
		}

		.min-home-range-item-text {
			width: 100%;
			height: auto;
			font-size: 0.875rem;
			color: #888888;
			line-height: 1.5rem;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 3;
			overflow: hidden;
		}




		/* 案例展示 */
		.min-home-case {
			width: 100%;
			height: auto;
			/* padding: 0 0.9375rem; */
			box-sizing: border-box;
			padding-top: 1.5rem;
			background: #ffffff;
			margin-top: 0.625rem;
			padding-bottom: 1.5rem;
		}

		.min-home-case-tit {
			width: 100%;
			height: 1.625rem;
			/* background: red; */
			margin-bottom: 1.5rem;
			box-sizing: border-box;
		}

		.min-home-case-tit-in {
			width: 11.90625rem;
			height: 1.625rem;
			background-image: url(../assets/minanlizhanshi.png);
			background-size: 100% 100%;
			margin: 0 auto;
		}

		.min-home-case-item-box {
			width: 100%;
			height: auto;
			/* background: pink; */
			padding: 0 0.9375rem 0 0.3125rem;
			box-sizing: border-box;
		}

		.min-home-case-item {
			width: calc(100% / 2 - 10px);
			/* height: 18.125rem; */
			background: #f8f8f8;
			/* float: left; */
			display: inline-block;
			margin-left: 0.625rem;
			box-sizing: border-box;
			margin-bottom: 0.625rem;
			/* padding: 0 0.625rem; */
			vertical-align: top;
			padding-bottom: 0.625rem;
		}

		.min-home-case-gengduo {
			width: 5.5rem;
			height: 1.875rem;
			/* background: #4f4f4f; */
			border: 1px solid #fed24f;
			text-align: center;
			line-height: 1.875rem;
			font-size: 0.875rem;
			color: #fed24f;
			margin: 0 auto;
			margin-top: 2.1875rem;
			box-sizing: border-box;
			border-radius: 5px;
		}

		.min-home-case-item-img {
			width: 100%;
			/* height: 10rem; */
			background: #ededed;
			overflow: hidden;
		}

		.min-home-case-item-tit {
			width: 100%;
			height: auto;
			font-size: 1rem;
			color: #353535;
			padding: 0.875rem 0.625rem 0.5rem 0.625rem;
			box-sizing: border-box;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.min-home-case-item-text {
			width: 100%;
			height: auto;
			font-size: 0.875rem;
			color: #888888;
			line-height: 1.5rem;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 3;
			overflow: hidden;
			padding: 0 0.625rem;
			box-sizing: border-box;
		}

		.min-home-case-fenlei {
			width: 100%;
			height: auto;
			/* background: red; */
			padding: 0 0.9375rem;
			box-sizing: border-box;
			margin-bottom: 0.625rem;
		}

		.min-home-case-fenlei-item {
			/* width: calc(100% / 4 - 10px); */
			width: auto;
			height: 2rem;
			padding: 0 0.625rem;
			text-align: center;
			border: 1px solid #ededed;
			line-height: 2rem;
			font-size: 0.875rem;
			color: #ffffff;
			box-sizing: border-box;
			display: inline-block;
			vertical-align: top;
			margin-bottom: 0.625rem;
			margin-right: 0.625rem;
			border-radius: 0.3125rem;
			color: #a9a9a9;
		}

		.min-home-case-fenlei-item-xz {
			background: #52dedb;
			color: #ffffff;
			border: 1px solid #52dedb;
		}






		.min-home-hezuo {
			width: 100%;
			height: auto;
			/* background: red; */
			padding: 3.125rem 0 0 0.625rem;

			box-sizing: border-box;
		}

		.min-home-hezuo-item {
			width: calc(50% - 20px);
			height: auto;
			float: left;
			/* background: pink; */
			margin-left: 0.625rem;
			margin-bottom: 0.625rem;
			box-sizing: border-box;
		}

		.min-home-news {
			width: 100%;
			height: auto;
			background: red;
			padding: 1.5rem 1.25rem 1.5rem 1.25rem;
			box-sizing: border-box;
			background: #f8f8f8;
		}

		.min-home-news-item {
			width: 100%;
			height: 6.25rem;
			background: #ffffff;
			padding: 0.625rem 0.625rem;
			box-sizing: border-box;
			margin-bottom: 1.25rem;

		}

		.min-home-news-item-left {
			width: 4.375rem;
			height: 100%;
			background: #52dedb;
			float: left;
			text-align: center;
			line-height: 5rem;
			font-size: 1rem;
			color: #ffffff;
			border-radius: 0.625rem;
		}

		.min-home-news-item-right {
			width: calc(100% - 4.375rem);
			height: 100%;
			/* background: red; */
			float: left;
			padding: 0 0 0 0.9375rem;
			box-sizing: border-box;
		}

		.min-home-news-item-right-tit {
			width: 100%;
			height: auto;
			font-size: 1rem;
			padding: 0.1875rem 0 0 0;
			box-sizing: border-box;
			color: #353535;
			/* 超过2行省略号 */
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 1;
			overflow: hidden;
		}

		.min-home-news-item-right-text {
			width: 100%;
			height: auto;
			font-size: 0.875rem;
			margin-top: 0.3125rem;
			color: #a9a9a9;
			line-height: 1.375rem;
			/* 超过2行省略号 */
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
			overflow: hidden;
		}

		.min-home-lianxiwm {
			width: 100%;
			height: 14.84375rem;
			/* background: #1aa7ee; */
			background-image: url(../assets/minhomelianxiwm.png);
			background-size: 100% 100%;
			padding: 2.5rem 0 0 0rem;
			box-sizing: border-box;
		}

		.min-home-bottom {
			width: 100%;
			height: 5rem;
			background: #343434;
			padding-top: 0.875rem;
			/* padding-left: 1.25rem; */
			box-sizing: border-box;
		}

		.min-my-swipe {
			width: 100%;
			height: 15.625rem;
			/* height: auto; */
		}

		.min-img {
			width: 100%;
			height: 15.625rem;
		}

		.min-icon {
			width: 100%;
			/* height: 6.5625rem; */
			height: 7.1875rem;
			background: #ffffff;
		}

		.min-icon-item {
			width: calc(100% / 4);
			height: 100%;
			/* background: pink; */
			float: left;
		}

		.min-icon-item-top {
			width: 2.8125rem;
			height: 2.8125rem;
			background: #dedede;
			border-radius: 50%;
			margin: 1.5rem auto 0 auto;
			box-sizing: border-box;
		}

		.min-icon-item-text {
			width: 100%;
			text-align: center;
			font-size: 0.875rem;
			color: #555555;
			margin-top: 0.375rem;
			box-sizing: border-box;
		}

		.min-home-honor {
			width: 100%;
			height: auto;
			/* height: 62.5rem; */
			box-sizing: border-box;
			padding-top: 1.5rem;
			background: #ffffff;
			margin-top: 0.625rem;
			padding-bottom: 1.5rem;
		}

		.min-home-honor-tit {
			width: 100%;
			height: 1.625rem;
			/* background: red; */
			margin-bottom: 1.5rem;
			box-sizing: border-box;
		}

		.min-home-honor-tit-in {
			width: 8.8125rem;
			height: 100%;
			background-image: url(../assets/minrongyutit.png);
			background-size: 100% 100%;
			margin: 0 auto;
		}
		.min-home-honor-tit-in-hezuohuoban{
			background-image: url(../assets/minhezuohuoban.png);
			width: 11.40625rem;
		}
		.min-home-honor-tit-in-xinwenzixun{
			background-image: url(../assets/minxinwenzixun.png);
			width: 17.125rem;
			height: 1.625rem;
		}

		.min-home-honor-item-box {
			width: 100%;
			height: auto;
			/* background: red; */
		}

		.min-home-honor-item {
			width: calc(100% / 2);
			height: auto;
			/* background: pink; */
			display: inline-block;
			vertical-align: top;
		}
		.min-home-range-item-top div{
			width: 0.4375rem;
			height: 0.75rem;
			background: #52dedb;
			display: inline-block;
			margin-right: 0.4375rem;
			box-sizing: border-box;
			border-radius: 0.625rem;
		}



	}
</style>
